import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/BenceIntro.css';

const FULL_TEXT = 'oooooooweeeeeeeee';
const DURATION = 8000;

const BenceIntro = ({ onComplete }) => {
  const [displayText, setDisplayText] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    const interval = DURATION / FULL_TEXT.length;
    let i = 0;
    const timer = setInterval(() => {
      i++;
      setDisplayText(FULL_TEXT.slice(0, i));
      if (i >= FULL_TEXT.length) {
        clearInterval(timer);
        setTimeout(() => setDone(true), 800);
        setTimeout(() => onComplete(), 1400);
      }
    }, interval);
    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="bence-intro"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="bence-chalkboard">
            <span className="bence-text">{displayText}</span>
            <span className="bence-cursor">|</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BenceIntro;
